var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecorativeLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 6,
    viewBox: "0 0 68 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 6,
    width: 52,
    height: 6,
    rx: 3,
    transform: "rotate(180 68 6)",
    fill: "#06CEA8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 6,
    width: 22,
    height: 6,
    rx: 3,
    transform: "rotate(180 22 6)",
    fill: "#C1B7ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorativeLine1);
export default __webpack_public_path__ + "static/media/decorative-line-1.64d6f2ea79e9c1b595522473217010a3.svg";
export { ForwardRef as ReactComponent };